'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _validator = require('validator');

var _validator2 = _interopRequireDefault(_validator);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _rules = require('../Webform/rules');

var _rules2 = _interopRequireDefault(_rules);

var _RuleHint = require('../RuleHint');

var _RuleHint2 = _interopRequireDefault(_RuleHint);

var _LookUp = require('../LookUp');

var _LookUp2 = _interopRequireDefault(_LookUp);

var _WebformUtils = require('../WebformUtils');

var _WebformUtils2 = _interopRequireDefault(_WebformUtils);

var _Form = require('../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

var _email = require('./styled/email');

var _email2 = _interopRequireDefault(_email);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailField = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(EmailField, _Component);

  function EmailField(props) {
    (0, _classCallCheck3.default)(this, EmailField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EmailField.__proto__ || (0, _getPrototypeOf2.default)(EmailField)).call(this, props));

    _this.lookUpFields = {
      email: {
        elementKey: 'email',
        formKey: props.field['#webform_key'],
        triggerLookUp: true,
        apiValue: function apiValue() {
          return false;
        },
        required: true
      }
    };
    _this.lookUpBase = props.url + '/neverbounce/validate-single?_format=json';

    var lookUpKey = _this.getLookUpKey(props);
    var field = props.formStore.getField(props.field['#webform_key']);

    _rules2.default.set('email_' + props.field['#webform_key'], {
      rule: function rule() {
        return field.isEmpty || _validator2.default.isEmail(field.value);
      },
      hint: function hint(value) {
        return _react2.default.createElement(_RuleHint2.default, { key: 'email_' + props.field['#webform_key'], hint: _WebformUtils2.default.getCustomValue(props.field, 'emailError', props.settings) || _WebformUtils2.default.getErrorMessage(field.element, '#required_error') || 'Please enter a valid email.', tokens: { value: value } });
      },
      shouldValidate: function shouldValidate() {
        return field.isBlurred && !field.isEmpty;
      }
    });
    _rules2.default.set('email_neverbounce_' + props.field['#webform_key'], {
      rule: function rule() {
        var lookUp = (0, _mobx.get)(field.lookUps, lookUpKey);
        return field.isEmpty || !lookUp || lookUp.lookUpSuccessful;
      },
      hint: function hint() {
        return _react2.default.createElement(_RuleHint2.default, { key: 'email_neverbounce_' + props.field['#webform_key'], hint: _WebformUtils2.default.getCustomValue(props.field, 'neverBounceError', props.settings) || _WebformUtils2.default.getErrorMessage(field.element, '#required_error') || 'Please enter a valid email.' });
      },
      shouldValidate: function shouldValidate() {
        return field.isBlurred && !field.isEmpty && _validator2.default.isEmail(field.value);
      }
    });

    props.registerLookUp(lookUpKey, _this.lookUpFields);
    return _this;
  }

  (0, _createClass3.default)(EmailField, [{
    key: 'getLookUpKey',
    value: function getLookUpKey(props) {
      return (props || this.props).field['#webform_key'] + '-email';
    }
  }, {
    key: 'prepareLookUp',
    value: function prepareLookUp(fields) {
      var emailField = this.props.getField('email');

      if (!fields.email || !emailField.field || _WebformUtils2.default.isEmpty(emailField.field.props, fields.email) || !_validator2.default.isEmail(fields.email)) {
        return false;
      }

      var query = '&email=' + fields.email;

      return {
        query: query,
        checkResponse: function checkResponse(json) {
          return json.success ? json : false;
        },
        isSuccessful: function isSuccessful(response) {
          return response.result !== 1;
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_email2.default, (0, _extends3.default)({}, this.props, {
        type: 'email',
        autoComplete: 'email'
      }));
    }
  }]);
  return EmailField;
}(_react.Component), _class2.meta = {
  validations: [function (el) {
    return 'email_' + el.key;
  }, function (el) {
    return 'email_neverbounce_' + el.key;
  }]
}, _class2.propTypes = {
  field: _propTypes2.default.shape({
    '#webform_key': _propTypes2.default.string.isRequired,
    '#emailError': _propTypes2.default.string,
    '#neverBounceEmail': _propTypes2.default.string
  }).isRequired,
  getField: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  settings: _propTypes2.default.shape().isRequired,
  url: _propTypes2.default.string.isRequired,
  formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired,
  registerLookUp: _propTypes2.default.func.isRequired
}, _temp)) || _class;

exports.default = (0, _LookUp2.default)(EmailField);